export const createUserObject = (data, formData) => {
  return {
    id: data.userId || data._id || data.user?.id,
    name: data.name || data.user?.name || formData.email.split("@")[0],
    email: data.email || data.user?.email || formData.email,
    plan: data.plan || data.user?.plan || "free",
    subscriptions: data.subscriptions || [],
  };
};